"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SESSION_REPLAY_RETENTION = {
    DEFAULT: 30,
    MIN: 1,
    MAX: 390,
};
//# sourceMappingURL=session-replay.limits.js.map